import React, { useEffect, useState } from 'react'
import { dataProps } from '../../../utils/contentful'

let __displayModMarker

export const displayModMarker = () => {
  if (typeof window === 'undefined') return false
  if (typeof __displayModMarker === 'undefined') {
    try {
      __displayModMarker = window.localStorage?.getItem('evcore/mod-marker')
    } catch (e) {
      // swallow
    }
  }
  return __displayModMarker
}

export default ({ entity }) => {
  const [init, setInit] = useState()
  useEffect(() => setInit(typeof window !== 'undefined'), [])
  return init ? <script type='application/mod-marker' {...dataProps(entity)} /> : null
}
